module.exports = __webpack_public_path__ + "img/banner.6dce4202.png";